import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppealService } from 'src/app/core/services/appeal.service';


interface AssessmentAccount {
  mde_name: string;
  mde_questionaireaccountsid: string;
}

@Component({
  selector: 'app-appeal-select',
  templateUrl: './appeal-select.component.html',
  styleUrls: ['./appeal-select.component.css']
})
export class AppealSelectComponent implements OnInit {
  isArabic!: boolean;
  assessmentAccounts: AssessmentAccount[] = [];
  form!: FormGroup;
  appealList: any[] = [];
  userData: any;
 
  constructor(
    private router: Router,
    private storageService: StorageService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private appealService: AppealService
  ) {}

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.form = this.fb.group({
      appeal: [''] // default empty
    });
    const requestData = {
      assessmentUnitGuid: this.userData?.assessmentUnitValue,
    };
    this.appealService.fetchAppealList(requestData).subscribe((res) => {
      if (res?.data) {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        let resp = JSON.parse(JSON.stringify(decryptedData));
        this.appealList = resp;
        if (this.appealList.length > 0) {
          this.storageService.setSessionStorageData('appealCount', this.appealList.length);
          this.form.patchValue({
            appeal: this.appealList[0].mde_questionaireaccountsid
          });
        } else {
          this.form.patchValue({ appeal: '' });
        }
      }
    }, 
    (error: any) => { 
      console.error('Error fetching appeal list', error);
      this.form.patchValue({ appeal: '' });
    });
  }

  goToDetail() {
    const selectedId = this.form.get('appeal')?.value;
    this.storageService.setSessionStorageData('appealId', selectedId);
    this.storageService.removeSessionStorageData('appealHistorical');
    if (selectedId) {
      this.router.navigate(
        ['/executor-dashboard/appeal/detail'],
        { state: { appealId: selectedId,appealHistorical:false } }
      );
    } else {
      alert('Please select an assessment first.');
    }
  }
}
